// extracted by mini-css-extract-plugin
module.exports = {"content":"HeroContent_content__x_7m5","logo":"HeroContent_logo__Y_aHj","title":"HeroContent_title__kPH8Z","text":"HeroContent_text__gEwQV"};